import PropTypes from 'prop-types';
import Styled from './validation-error-component-style';

/**
 * Error message component
 *
 * @param {string} message - message string to display
 * @returns {JSX} - Error message component
 */
const ValidationErrorMessage = ({ message }) =>
  message ? (
    <Styled.ErrorMessage>{message}</Styled.ErrorMessage>
  ) : (
    <Styled.NoErrorMessage />
  );

ValidationErrorMessage.propTypes = {
  message: PropTypes.string,
};

ValidationErrorMessage.defaultProps = {
  message: '',
};

export default ValidationErrorMessage;
